import React, { useEffect } from 'react';
import { Form, Input, Button, InputNumber, Switch } from 'antd';
import { AppSelectorInput } from './AppSelector';

const PartnerForm = ({ item, _onClose, onSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (item) {
      form.setFieldsValue(item);
    } else {
      form.resetFields();
    }
  }, [item, form]);

  const handleFinish = (values) => {
    console.log('onFinish values:', values);
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      onValuesChange={(changed, allValues) => {
        console.log('onValuesChange:', allValues);
      }}
    >
      <Form.Item name="title" label="Title" rules={[{ required: true, message: 'Title is required' }]}>
        <Input />
      </Form.Item>
      <Form.Item
        name="shopifyAppUrl"
        label="Shopify App URL"
        rules={[{ required: true, message: 'Shopify App URL is required' }]}
      >
        <Input />
      </Form.Item>
      <p style={{ marginTop: -15, marginBottom: 35 }}>
        URL TRÊN APP STORE - NẾU ĐIỀN URL NGOÀI THÌ SẼ KHÔNG CRAWL ĐƯỢC
      </p>
      <Form.Item name="openAppBannerUrl" label="Link to open on BANNER of app">
        <Input />
      </Form.Item>
      <p style={{ marginTop: -15, marginBottom: 35 }}>
        url người dùng sẽ mở khi click vào banner TRÊN CÙNG của partner page trên app
      </p>
      <Form.Item
        name="openAppUrl"
        label="Link to open on other places of app"
        rules={[
          {
            required: true,
            message: 'Link to open on app is required',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <p style={{ marginTop: -15, marginBottom: 35 }}>
        URL NGƯỜI DÙNG SẼ MỞ KHI CLICK PARTER VÀO CÁC CHỖ KHÁC (LISTING...)
      </p>
      <AppSelectorInput name="category" label="Show on app" required={true} placeholder="Show on app" />
      <Form.Item name="icon" label="Icon URL">
        <Input />
      </Form.Item>
      <Form.Item name="banners" label="Banners (comma separated URLs)">
        <Input />
      </Form.Item>
      <Form.Item name="shortDescription" label="Short Description">
        <Input />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item name="featuresList" label="Features List">
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item name="reviewRate" label="Review Rate">
        <InputNumber min={0} max={5} step={0.1} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="shopifyAppId" label="Shopify App ID">
        <Input />
      </Form.Item>
      <Form.Item name="isBuiltForShopify" label="Built for Shopify" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PartnerForm;

